import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./SinglesRunClub.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import Multiselect from "multiselect-react-dropdown";



const images = [
  "assests/images/run-slide1.jpg",
  "assests/images/run-slide2.jpg",
  "assests/images/run-slide3.jpg",
  "assests/images/run-slide4.jpg",
  "assests/images/run-slide5.jpg",
  "assests/images/run-slide6.jpg",
  "assests/images/run-slide7.jpg",
  "assests/images/run-slide8.jpg",
];

const SinglesRunClub = () => {

  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: '13%',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };
  
  

  // const [showImage, setShowImage] = useState(false);

  // const handleVideoError = () => {
  //   setShowImage(true);
  // };

	const [loading,setLoading] = useState(true);

	const [events, setEvents] = useState([]);

 const [selected, setSelected] = useState([]);

	const [location, setLocation] = useState([]);

  const navigate = useNavigate();

  // const [index, setIndex] = useState(0);
  
  // const handleSelect = (selectedIndex) => {
  //   setIndex(selectedIndex);
  // };

  // const [isSliding, setIsSliding] = useState(false);




  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
    document.title = `YFMF Singles Run Club Ireland  `;
    document.getElementById('bodywrap').className='runclub';
	
    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Join the YFMF Singles Run Club — the perfect mix of fitness and fun. Meet other like-minded singles for a casual run followed my snacks and mingle.");
      } 
	
	/* Start get even data */
	let formData1 = new FormData(); 
		formData1.append('type', '');
    formData1.append('location_type', 'singles-run-club');
		API.post('get_events', formData1)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
			   setEvents(response.data.data.event);
			}                  
		}).catch(error => {
			 
		});  
	 /* End get even data */
	 
	 /* Start get location data */
		API.get('get_location')
			.then(response => {
			if(response.data.status === false){
				
			}else{
			   setLocation(response.data.data);
			}                  
		}).catch(error => {
			 
		});  
	 /* End get location data */
	
  },[]);  


const handleInputChangeLoc = (selectedList) => {
    //selectedList.persist();
    setSelected(selectedList);

    

    const allNewLoc = [];
    selectedList.forEach((val) => {
      allNewLoc.push(val.id);
    });

    let formData = new FormData();
    formData.append("type", "");
    formData.append('location_type', 'singles-run-club');
    formData.append("location_id", JSON.stringify(allNewLoc));

    API.post("get_events", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          setEvents(response.data.data.event);
        }
      })
      .catch((error) => {});
  };

const handleLink = (is_event_private,id) => {
      window.location.href = "/event-product/"+id;
}


  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/singu-run.jpg'}
          alt=""
          className="img-fluid"
        />
      </div>

      <div className="container-fluid events">
        <div className="row d-flex">
          <div className="col-md-4 order-1 order-md-1 d-flex flex-column flex-grow-1">
            <div className="tired">
              <h2>Singles Run Club </h2>
              <h4>Meet, Move & Mingle</h4>
            </div>
            <div className="tired-2 mt-auto">
              <p className="mb-4">
                A fun and casual 5KM run (or walk) at your own pace, designed to
                bring singles together in a relaxed, social setting. Whether
                you're a seasoned runner or just looking for a new way to meet
                people, this is the perfect way to get active, connect with
                like-minded singles, and enjoy great conversation
              </p>
              <p>
                Each event welcomes 50-80 singles and is all about easy, natural
                interactions with people who share similar interests.
              </p>
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                View upcoming events
              </Link>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center order-2 order-md-2 flex-grow-1">
            <img
              src={process.env.REACT_APP_BASE_URL + "assests/images/mingle.png"}
              alt="TikTok"
              className="img-fluid"
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="col-md-4 d-flex align-items-end flex-grow-1 order-3 order-md-3">
            <div className="uk">
              <p>
                Join us on Sunday mornings for a run followed by complimentary
                coffee and snacks at a local coffee shop, or Wednesday nights
                for a midweek run ending with pints and bites at a local pub
              </p>
              <p>
                Need a wingman? No problem—bring a friend along! If you're
                single, wear black; if you're taken, wear colour. No pressure,
                no awkward moments—just a great way to meet new people while
                staying active
              </p>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center d-md-none order-4">
            <Link to="/upcoming-events" className="brow-bu text-decoration-none">
              View upcoming events
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid video-containers d-flex justify-content-center align-items-center">
        <div className="video-container position-relative">
          <video autoPlay muted loop playsInline className="video-content">
            <source
              src={
                process.env.REACT_APP_BASE_URL + "assests/images/video-4.mp4"
              }
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>

          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/fallback.png"}
            alt="Fallback"
            className="fallback-image"
          />
        </div>
      </div>

      <div className="container-fluid discover up-even disroveru pt-0">
        <h1>UPCOMING RUNS</h1>
        <h2>Join us for your next run!</h2>
        {/*<div className="tabsu row mb-5 g-4">
          <div className="col-auto dibli">
            <Link
              href="#"
              className={selectedCity === 0 ? "selected" : ""}
              onClick={(e) => {
                e.preventDefault();
                setSelectedCityset(0);
              }}
            >
              All
            </Link>
          </div>
          {location.length > 0 &&
            location.map((item, index) => {
              return (
                <div className="col-auto dibli">
                  <Link
                    href="#"
                    className={selectedCity === item.id ? "selected" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedCityset(item.id);
                    }}
                  >
                    {item.name}
                  </Link>
                </div>
              );
            })}
        </div>*/}
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-5">
            <div className="col-12 col-md-auto files">Filter by</div>
            <div className="d-flex flex-column flex-md-row gap-2 alag">
              <div className="col-12 col-md-10 fil-name mb-2 mb-md-0">
                <Multiselect
                  options={location}
                  selectedValues={selected} // 👈 Here you put your pre-selected values
                  onSelect={handleInputChangeLoc}
                  onRemove={handleInputChangeLoc}
                  displayValue="name"
                  showCheckbox
                  placeholder="Select Location"
                />
              </div>
             
            </div>
          </div>
        <div className="d-none d-md-flex row">
          {events.map((val, i) => (
            <div className="col-md-4 mb-4 joker">
              <div className="card vesi h-100 d-flex flex-column position-relative">
                <Link
                  to="#"
                  className="text-decoration-none"
                  onClick={() => handleLink(val.is_event_private,val.id)}
                >
                  <img
                    src={val.event_image}
                    className="card-img-top"
                    alt={val.event_title}
                  />
                </Link>
                <h5 className={`text-center event-cat-box${val.category_id}`} >{val.category_name}</h5>
                <div className="card-body d-flex flex-column">
                  <div className="datesx">
                    <div className="day-number">{val.day}</div>
                    <div className="day-month">{val.month}</div>  
                  </div>
                  <Link
                    to="#"
                    className="text-decoration-none"
                    onClick={() => handleLink(val.is_event_private,val.id)}
                  >
                    <h5>
                      {val.event_title}{" "}
                      {/*(Ages {val.age_start} - {val.age_end})*/}
                    </h5>
                  </Link>
                  <p>{val.event_address}</p>
                  <div className="d-flex gap-2 flex-wrap">
                  {(() => {
                if (val.age_start==='' && val.age_end==='') {
                  } else if (val.age_start!=='' && val.age_end==='') {
                    return ( <h3>Age {val.age_start}+</h3>)
                  }else if (val.age_start==='' && val.age_end!=='') {
                      return ( <h3>Age {val.age_end}+</h3>)
                  }else if (val.age_start!=='' && val.age_end!=='') {
                    return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
                  }
                })()}
                {val.tags.map((val1, index1) => {
                return (
                <h3>{val1}</h3>
              )
              })}
                </div>
                  <div className="mt-auto">
                    <Link
                      to="#"
                      className="text-decoration-none"
                      onClick={() => handleLink(val.is_event_private,val.id)}
                    >
                      <div className="get-ti">
                        <Link
                          to="#"
                          className="w-100 text-decoration-none"
                        >
                          GET TICKETS
                        </Link>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-block d-md-none">
          {events.length > 0 && (
            <Carousel className="p-0">
              {events.map((val, i) => (
                <Carousel.Item className="px-2 joker">
                  <div className="card position-relative">
                    <Link
                      to="#"
                      className="text-decoration-none"
                      onClick={() => handleLink(val.is_event_private,val.id)}
                    >
                      <img
                        src={val.event_image}
                        className="card-img-top"
                        alt={val.event_title}
                      />
                    </Link>
                    <h5 className={`text-center event-cat-box${val.category_id}`} >{val.category_name}</h5>
                    <div className="card-body">
                      <div className="datesx">
                        <div className="day-number">{val.day}</div>
                        <div className="day-month">{val.month}</div>  
                      </div>
                      <Link
                        to="#"
                        className="text-decoration-none"
                        onClick={() => handleLink(val.is_event_private,val.id)}
                      >
                        <h5>
                          {val.event_title}{" "}
                          {/*(Ages {val.age_start} - {val.age_end})*/}
                        </h5>
                      </Link>
                      <p>{val.event_address}</p>
                      {(() => {
                if (val.age_start==='' && val.age_end==='') {
                  } else if (val.age_start!=='' && val.age_end==='') {
                    return ( <h3>Age {val.age_start}</h3>)
                  }else if (val.age_start==='' && val.age_end!=='') {
                      return ( <h3>Age {val.age_end}</h3>)
                  }else if (val.age_start!=='' && val.age_end!=='') {
                    return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
                  }
                })()}
                      <Link
                        to="#"
                        className="text-decoration-none"
                        onClick={() => handleLink(val.is_event_private,val.id)}
                      >
                        <div className="get-ti">
                          <Link
                            to="#"
                            className="w-100 text-decoration-none"
                          >
                            GET TICKETS
                          </Link>
                        </div>
                      </Link>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </div>

        <div className="text-center mt-4">
          <button className="btn" onClick={() => navigate("/upcoming-events")}>
            BROWSE ALL EVENTS
          </button>
        </div>
      </div>

      <div className="container-fluid real-connection new-real">
        <div className="row justify-content-between">
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>SINGLES RUN CLUB</h6>
              <h2>It's all about the chase</h2>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-7 pe-md-0">
            <div>
              <Slider ref={sliderRef} {...settings}>
                {images.map((img, i) => (
                  <div key={i} className={`custom-slide ${i === images.length - 1 ? 'last-slide' : ''}`}>
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "460px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="conainer-fluid accors">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Any questions?</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What is the Singles Run Club?
                </Accordion.Header>
                <Accordion.Body>
                  It’ s a relaxed 5km run (or walk!) where singles come together
                  to get some fresh air, meet new people, and chat over coffee
                  or a pint afterwards. No awkward setups — just good vibes and
                  genuine connections.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Do I have to be arunner to join?
                </Accordion.Header>
                <Accordion.Body>
                  Not at all! You can walk, jog, or run — whatever pace feels
                  good for you. It ’ s about meeting people, not setting
                  personal bests.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>What should I wear?</Accordion.Header>
                <Accordion.Body>
                  Wear something comfortable for running or walking. If you ’re
                  single , wear black . If you ’ re taken , wear colour — simple
                  as that.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Can I come on my own?</Accordion.Header>
                <Accordion.Body>
                  Absolutely. Most people do! It’s a relaxed, no-pressure
                  environment and a great way tomeet like-minded singles.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>How long is the run?</Accordion.Header>
                <Accordion.Body>
                  Each event is a casual 5km route. You can go at your own pace
                  — there ’ s no pressure to keep up.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>What happens after the run?</Accordion.Header>
                <Accordion.Body>
                  After the run, we meet at a nearby café or pub for coffee and
                  snacks (Sundays) or pizza and pints (Wednesdays) — a perfect
                  time to mingle and chat.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  Is there an age range for the run club?
                </Accordion.Header>
                <Accordion.Body>
                  Our Run Clubs are generally aimed atsingles in their 20s to
                  40s, but age range may varyby event. Check the event
                  description for details.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  How many people usually attend?
                </Accordion.Header>
                <Accordion.Body>
                  Typically between 50 to 60 singles for our Sunday runs and 100
                  to 150 for our Wednesday evening run s . It ’ s a great -
                  sized group for relaxed conversation and meeting new faces.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>What if it rains?</Accordion.Header>
                <Accordion.Body>
                  We run rain or shine! Just bring a jacket or cap if it looks
                  like wet weather. We promise the post - run coffee or pint
                  will be worth it.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  What if I can’t keep up with the group?
                </Accordion.Header>
                <Accordion.Body>
                  No problem at all. You can go at your own pace—walk, jog, or
                  run. There’s no pressure,and plenty of people move at
                  different speeds. It’s all about the social side, not how
                  fastyou go.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10" className="hololast">
                <Accordion.Header>
                  Do I need to book in advance?
                </Accordion.Header>
                <Accordion.Body>
                  Yes—tickets are limited and usually sell out quickly, so we
                  recommend booking early.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Appqr />
      <Footer />
    </>
  );
};

export default SinglesRunClub;
